<template>
  <div>
    <router-view />
    <p>This is just a test page</p>
  </div>
</template>

<script>

export default {
    created() {
    },
    methods: {
    },
};
</script>
